import * as v from "valibot";

// request schema
export const ReleaseInstanceSchema = v.object({
  Namespace: v.nullish(v.string()),
  ReleaseName: v.nullish(v.string()),
});
export type ReleaseInstance = v.InferOutput<typeof ReleaseInstanceSchema>;

export const RequestSchema = v.object({
  ClusterId: v.string(),
  ReleaseInstances: v.array(ReleaseInstanceSchema),
  VpcId: v.string(),
});
export type Request = v.InferOutput<typeof RequestSchema>;

// response schema
export const LoadBalancerDescriptionSchema = v.object({
  ChargeType: v.string(),
  CreateTime: v.string(),
  IpVersion: v.string(),
  IsKceAvailable: v.boolean(),
  IsWaf: v.boolean(),
  LbStatus: v.string(),
  LbType: v.string(),
  ListenersCount: v.number(),
  LoadBalancerId: v.string(),
  LoadBalancerName: v.string(),
  LoadBalancerState: v.string(),
  ProjectId: v.string(),
  PublicIp: v.string(),
  State: v.string(),
  Type: v.string(),
  VpcId: v.string(),
});
export type LoadBalancerDescription = v.InferOutput<typeof LoadBalancerDescriptionSchema>;

export const IngressNginxLoadBalancerSchema = v.object({
  LoadBalancerDescription: LoadBalancerDescriptionSchema,
  Namespace: v.string(),
  ReleaseName: v.string(),
});
export type IngressNginxLoadBalancer = v.InferOutput<typeof IngressNginxLoadBalancerSchema>;

export const DataSchema = v.object({
  IngressNginxLoadBalancers: v.nullish(v.array(IngressNginxLoadBalancerSchema)),
});
export type Data = v.InferOutput<typeof DataSchema>;

export const ResponseSchema = v.object({
  Data: DataSchema,
  RequestId: v.string(),
});
export type Response = v.InferOutput<typeof ResponseSchema>;
